import { dataBreachRepository } from '../repositories/data-breach-repository';

async function getTrackedEmailWithBreaches(id) {
    if (!id) {
        throw Error('Invalid prameters');
    };

    return dataBreachRepository.getBreaches(id);
};

export {
    getTrackedEmailWithBreaches
};
